<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10nOrou/tc-custom/9781576753422.jpg?1701061265451" alt="This image is the cover for the book Be the Hero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Be the Hero
      </h1>
      <p class="bookDescription body article font2">
        <b>An executive coach shares essential advice on how to succeed by being your best self—even at your worst moments.</b><br/><br/>Everyone faces frustration and stress, but we don’t have to let these challenging moments take control of us. In <i>Be the Hero</i>, executive coach Noah Blumenthal introduces us to the way of the “Everyday Hero” and shows how to turn self-defeating thoughts and behaviors into heroic actions.<br/><br/>All day long, without even realizing it, we tell ourselves dozens of stories about other people, our situations, and ourselves. These stories shape our emotions and behavior, making us think and act like either a hero or a victim. <i>Be the Hero</i> shows you how to choose the stories that lead to personal and professional success.<br/><br/>In the tradition of the best storytellers, Blumenthal weaves a tale of a young professional’s journey from victim to hero, one that is both captivating and profound. The powerful resources at the end of the book, including a hero tip of the week, smart cards, manager tip sheets, and more, will help you make your hero stories stick
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Noah Blumenthal, Marshall Goldsmith
      </h2>
      
      <p class="authorDescription body article">Noah Blumenthal is president of Leading Principles, Inc., an executive coaching and consulting company whose clients rank among the Fortune and Global 500, including MTV Networks, Hilton Hotels Corporation, and DuPont. A keynote speaker and author of You’re Addicted to You (Berrett-Koehler), he was named one of the world’s “Top 100 Minds on Personal Development” by Leadership Excellence magazine and has been featured in such leading media outlets as the New York Times, CBS News, MSNBC News, Chicago Sun-Times, Investor’s Business Daily, and Newsday.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publisher, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8a2482d2